<template>
  <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;">
    <div style="">
      <!--       -->
      <Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add" :src="require('@/assets/icon/icon-add.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.update" backgroundColor="#FFF" :useAutoOptional="false" :optional="!RowData" title="修改" fontSize="14px" @btnclick="update" :src="require('@/assets/icon/icon-update.png')">
      </Commonbtn>
      <Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del" :src="require('@/assets/icon/icon-del.png')">
      </Commonbtn>
      <Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export" :src="require('@/assets/icon/daoc.png')">
      </Commonbtn>
    </div>
    <!-- style="border: 1px solid blue;" -->
    <div class="TableWidth">
      <Commontable ref="ManufacturerRef" :loadingTable="loadingTableManufacturer" @onRowClick="onRowClick" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
      </Commontable>
      <div class="pagination">
        <Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total" :pageSize="pageSize"></Pagination>
      </div>
    </div>
    <DialogFrom width="1000px" :title="DialogFrom.title" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
      <div class="from" style="position: relative;overflow-y: scroll;min-height: 100px;">
        <template v-for="(item , index) of EditorFromData">
          <Commondropdownlist :key="index" ref="DialogFromref" :event="item.event" :disabledHB="item.disabled" :selcoms="item.selcoms" :widths="item.widths" :options="item.options" :btx="item.btx" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata" :disabled="item.disabled">
          </Commondropdownlist>
        </template>
      </div>
    </DialogFrom>
    <Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblesMessage" @cancel="cancelMessage" @dialogOK="dialogOKMessage" :src="Dialog.src">
      <span style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">{{ Dialog.title }}</span>
    </Dialog>
  </div>
</template>

<script>
import Commontable from '@/components/common-table.vue'
import Commonbtn from '@/components/common-btn.vue'
import Pagination from '@/components/pagination.vue'
import DialogFrom from '@/components/dialog-from.vue'
import Commondropdownlist from '@/components/common-dropdownlist.vue'
import Dialog from '@/components/dialog.vue'
import utils from '@/common/utils'
import headerData from './headerData/headerData'
import EditorFromData from './FromData/EditorFromData'
import {
  ManufacturerList,
  ManufacturerAdd,
  ManufacturerInfo,
  ManufacturerEdit,
  ManufacturerDelete,
  ManufacturerExport
} from '@/api/home'
export default {
  components: {
    Commontable,
    Commonbtn,
    Pagination,
    Commondropdownlist,
    DialogFrom,
    Dialog
  },
  props: {},
  data() {
    return {
      loadingTableManufacturer: true,
      dialogVisibles: false,
      dialogVisiblesMessage: false,
      total: 0,
      pageIndex: 1,
      pageSize: 20,
      RowData: null,
      tableData: [],
      headerData: [],
      EditorFromData: [],
      DialogFrom: {
        title: '加载中...'
      },
      Dialog: {
        title: '加载中...',
        src: require('@/assets/icon/icon-errors.png')
      },
      from: {
        MFName: '',
        Abbr: ''
      },
      qx: {
        add: false,
        update: false,
        del: false,
        stopif: true,
        daoc: true,
        assignment: false,
        enabled: false,
        submit: false,
        skip: false,//跳过
        reset: false, //重置
        setting: false,
        approval: false
      },
    }
  },
  created() {
    this.ManufacturerList();
  },
  mounted() {
    this.headerData = JSON.parse(JSON.stringify(headerData))
    this.EditorFromData = JSON.parse(JSON.stringify(EditorFromData))
  },
  activated() { },
  updated() { },
  methods: {
    // 列表
    async ManufacturerList() {
      let {
        data,
        message,
        code
      } = await ManufacturerList({
        PageSize: this.pageSize,
        PageIndex: this.PageIndex
      })
      if (code == 0) {
        this.total = data.Count
        this.tableData = data.data
      } else {
        this.$message.warning(message)
      }
    },
    // 导出
    async ManufacturerExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let resexprot = await ManufacturerExport({
        PageSize: this.pageSize,
        PageIndex: this.PageIndex
      })
      if (resexprot) {
        let date = new Date()
        let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
        utils.downloadFile(resexprot, `生产厂商档案${str}`, "xlsx")
        loading.close();
      } else {
        // 返回json
        this.$message.warning('导出失败');
        loading.close();
      }
      loading.close()
    },
    // 新增
    async ManufacturerAdd() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message
      } = await ManufacturerAdd({
        MFName: this.$refs.DialogFromref[0].modelvalue,
        Abbr: this.$refs.DialogFromref[1].modelvalue,
        ShortName: this.$refs.DialogFromref[2].modelvalue,
      })
      if (code == 0) {
        this.$message.success(message)
        this.dialogVisibles = false
        this.ManufacturerList()
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    // 详情
    async ManufacturerInfo() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        data,
        message
      } = await ManufacturerInfo({
        MFCode: this.RowData.MFCode
      })
      if (code == 0) {
        this.dialogVisibles = true
        this.DialogFrom.title = '修改'
        setTimeout(() => {
          this.$refs.DialogFromref[0].modelvalue = data.MFName
          this.$refs.DialogFromref[1].modelvalue = data.Abbr
          this.$refs.DialogFromref[2].modelvalue = data.ShortName
        }, 100)
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    // 修改
    async ManufacturerEdit() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message
      } = await ManufacturerEdit({
        MFCode: this.RowData.MFCode,
        MFName: this.$refs.DialogFromref[0].modelvalue,
        Abbr: this.$refs.DialogFromref[1].modelvalue,
        ShortName: this.$refs.DialogFromref[2].modelvalue,
      })
      if (code == 0) {
        this.$message.success(message)
        this.dialogVisibles = false
        this.ManufacturerList()
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    //删除
    async ManufacturerDelete() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255,255,255,0.3)'
      });
      let {
        code,
        message
      } = await ManufacturerDelete({
        MFCode: this.RowData.MFCode
      })
      if (code == 0) {
        this.$message.success(message)
        this.dialogVisiblesMessage = false
        this.ManufacturerList()
      } else {
        this.$message.warning(message)
      }
      loading.close()
    },
    Export() {
      this.ManufacturerExport()
    },
    add() {
      this.DialogFrom.title = '新增'
      this.dialogVisibles = true

    },

    update() {
      if (this.RowData) {
        this.ManufacturerInfo()

      } else {
        this.$message.warning('请选择您要操作的数据！')
      }
    },
    del() {
      if (this.RowData) {
        this.Dialog.title = '您确定要删除这条数据吗？'
        this.Dialog.src = require('@/assets/icon/icon-del2.png')
        this.dialogVisiblesMessage = true
      } else {
        this.$message.warning('请选择您要操作的数据！')
      }
    },
    onRowClick(row) {
      this.RowData = row
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.ManufacturerList()
    },
    handleSizeChange(pageSize) {
      this.pageSize = PageSize
      this.ManufacturerList()
    },
    cancel() {
      this.dialogVisibles = false
    },
    dialogOK() {
      if (this.DialogFrom.title == '新增') {
        this.ManufacturerAdd()
      } else if (this.DialogFrom.title == '修改') {
        this.ManufacturerEdit()
      }
    },
    cancelMessage() {
      this.dialogVisiblesMessage = false
    },
    dialogOKMessage() {
      if (this.Dialog.title == '您确定要删除这条数据吗？') {
        this.ManufacturerDelete()
      }
    }
  },
  computed: {},
  watch: {
    $route: {
      handler(to, from) {
        let data = JSON.parse(localStorage.getItem("MenusData"))
        data.Menus.forEach((item, index) => {
          if (item.NodeID == 9) {
            item.Nodes.forEach((items, indexs) => {
              if (items.NodeID == to.query.NodeID) {
                items.Nodes.forEach((itemes, indexes) => {
                  if (itemes.NodeID == to.query.MenuID) {
                    this.qus = itemes.Nodes
                  }
                })
              }
            })
          }
        });
        if (this.qus) {
          this.qus.map((item, index) => {
            if (item.NodeName == 'add') {
              this.qx.add = true
            } else if (item.NodeName == 'edit') {
              this.qx.update = true
            } else if (item.NodeName == 'delete') {
              this.qx.del = true
            } else if (item.NodeName == 'stopif') {
              this.qx.del = true
            } else if (item.NodeName == 'assignment') {
              this.qx.assignment = true
            } else if (item.NodeName == 'enabled') {
              this.qx.enabled = true
            } else if (item.NodeName == 'skip') {
              this.qx.skip = true
            } else if (item.NodeName == 'reset') {
              this.qx.reset = true
            } else if (item.NodeName == 'setting') {
              this.qx.setting = true
            } else if (item.NodeName == 'submit') {
              this.qx.submit = true
            } else if (item.NodeName == 'approval') {
              this.qx.approval = true
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
    dialogVisibles: {
      handler(dialogVisiblesNew, dialogVisiblesOld) {
        if (!dialogVisiblesNew) {
          this.$refs.DialogFromref.forEach((item, indedx) => {
            item.modelvalue = ''
          })
          this.DialogFrom.title = '加载中...'

        }

      }
    }
  },
}
</script>
<style scoped lang='less'>
</style>